import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Users, Eye } from 'lucide-react';
export function OnlineViewers() {
  const [viewers, setViewers] = useState(45);
  const [justChanged, setJustChanged] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      // Randomly change viewers between 38-52
      const change = Math.random() > 0.5 ? 1 : -1;
      setViewers(prev => {
        const newValue = prev + change;
        // Keep between 38 and 52
        return Math.max(38, Math.min(52, newValue));
      });
      setJustChanged(true);
      setTimeout(() => setJustChanged(false), 500);
    }, 8000); // Change every 8 seconds
    return () => clearInterval(interval);
  }, []);
  return <motion.div initial={{
    opacity: 0,
    scale: 0.9
  }} animate={{
    opacity: 1,
    scale: 1
  }} className="inline-flex items-center gap-2 bg-white border-2 border-amber-200 rounded-full px-4 py-2 shadow-md" data-id="element-116">
      <div className="relative" data-id="element-117">
        <Users className="w-4 h-4 text-amber-600" data-id="element-118" />
        <motion.div animate={{
        scale: [1, 1.2, 1]
      }} transition={{
        repeat: Infinity,
        duration: 2
      }} className="absolute -top-1 -right-1 w-2 h-2 bg-green-500 rounded-full" data-id="element-119" />
      </div>

      <AnimatePresence mode="wait" data-id="element-120">
        <motion.span key={viewers} initial={{
        y: 10,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: -10,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className={`font-bold text-sm ${justChanged ? 'text-amber-600' : 'text-navy-800'}`} data-id="element-121">
          {viewers}
        </motion.span>
      </AnimatePresence>

      <span className="text-xs text-navy-600 font-medium" data-id="element-122">
        personas viendo ahora
      </span>

      <Eye className="w-4 h-4 text-amber-500 animate-pulse" data-id="element-123" />
    </motion.div>;
}